export const messages = {
  en: {
    auditOpenShop: {
      title: 'Shop Audit',
      shopLogo: 'Shop Logo',
      shopName: 'Shop Name',
      shopType: 'Shop Type',
      storeName: 'Merchant Name',
      storeAddress: 'Merchant Address',
      storeTel: 'Contact Number',
      state: 'Status',
      operation: 'Operation',
      audit: 'Audit'
    }
  },
  zh: {
    auditOpenShop: {
      title: '开店审核',
      shopLogo: '店铺logo',
      shopName: '店铺名称',
      shopType: '店铺类型',
      storeName: '商家名称',
      storeAddress: '商家地址',
      storeTel: '联系电话',
      state: '状态',
      operation: '操作',
      audit: '审核'
    }
  }
}